import { useState, useCallback } from 'react'

const useToggle = (initialValue?: boolean) => {
  const [state, setState] = useState<boolean>(!!initialValue)
  const toggleState = useCallback(() => {
    setState((state) => !state)
  }, [])
  return [state, toggleState] as const
}
export default useToggle
